<div class="hr-slide-area">
  <div class="ol-template-back-bar"></div>
  <div class="ol-template-slide-data">
    <div class="slide-data-area">
      <div class="ol-template-slide-info">
        <div
          class="ol-template-slide-title"
          [innerHTML]="initialValue.title"
        ></div>
        <div class="wage-box">
          <div class="wage-title-area">
            <div
              class="title"
              [ngClass]="{
                withouVariableWageTitle: !initialValue.showVariableWage
              }"
            >
              {{ (salaryType === "horista" ? "offerLetter.template.hourlyWage" : "offerLetter.template.monthlyWage") | translate }}
            </div>
            <div class="title" *ngIf="initialValue.showVariableWage">
              {{ "offerLetter.template.variableWage" | translate }}
            </div>
          </div>
          <div
            class="wages"
            [ngClass]="{
              withouVariableWageSubtitle: !initialValue.showVariableWage
            }"
          >
            <div
              class="wage-area"
              [ngClass]="{
                withouVariableWageSubtitleArea: !initialValue.showVariableWage
              }"
            >
              <div class="icon-area">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/modules/carta-oferta/template/wage-offer.svg"
                ></svg-icon>
              </div>
              <div class="wage-data">
                <div class="wage">
                  {{ getCurrencyHelper(salario) }}{{ salaryType === "horista" ? "/hora" : "" }}
                </div>
                <div
                  class="description"
                  [innerHTML]="initialValue.wageSubtitle"
                ></div>
              </div>
            </div>

            <div class="wage-area" *ngIf="initialValue.showVariableWage">
              <div class="icon-area">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/modules/carta-oferta/template/wage-offer.svg"
                ></svg-icon>
              </div>
              <div class="wage-data">
                <div class="wage" [innerHTML]="initialValue.variableWage"></div>
                <div
                  class="description"
                  [innerHTML]="initialValue.variableWageSubtitle"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="wage-box-mobile">
          <div class="wage-container first-wage">
            <div class="wage-title-area">
              <div class="title">
                {{ (salaryType === "horista" ? "offerLetter.template.hourlyWage" : "offerLetter.template.monthlyWage") | translate }}
              </div>
            </div>

            <div class="wages">
              <div class="wage-area">
                <div class="icon-area">
                  <svg-icon
                    class="hr-svg-icon"
                    src="/assets/icons/modules/carta-oferta/template/wage-offer.svg"
                  ></svg-icon>
                </div>
                <div class="wage-data">
                  <div class="wage">
                  {{ getCurrencyHelper(salario) }}{{ salaryType === "horista" ? "/hora" : "" }}
                  </div>
                  <div
                    class="description"
                    [innerHTML]="initialValue.wageSubtitle"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="wage-container second-wage"
            *ngIf="initialValue.showVariableWage"
          >
            <div class="wage-title-area">
              <div class="title">
                {{ "offerLetter.template.variableWage" | translate }}
              </div>
            </div>
            <div class="wages">
              <div class="wage-area">
                <div class="icon-area">
                  <svg-icon
                    class="hr-svg-icon"
                    src="/assets/icons/modules/carta-oferta/template/wage-offer.svg"
                  ></svg-icon>
                </div>
                <div class="wage-data">
                  <div
                    class="wage"
                    [innerHTML]="initialValue.variableWage"
                  ></div>
                  <div
                    class="description"
                    [innerHTML]="initialValue.variableWageSubtitle"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="extra-info-area"
          *ngIf="grupoSalarialName || dataBase || remuneracaoExtra.length"
        >
          <div class="title">Remuneração</div>
          <div class="infos">
            <div class="info" *ngIf="grupoSalarialName">
              <div class="info-data">
                <span class="info-title">{{ olNames ? olNames.grupo_salarial : ("general.grupoSalarial" | translate) }}: </span>
                <span class="info-value">{{ grupoSalarialName }}</span>
              </div>
            </div>
            <div class="info" *ngIf="dataBase">
              <div class="info-data">
                <span class="info-title">Data-base: </span>
                <span class="info-value">{{ dataBase }}</span>
              </div>
            </div>
            <div class="info" *ngFor="let item of remuneracaoExtra">
              <div class="info-data">
                <span class="info-title">{{ item.title }}: </span>
                <span class="info-value" [innerHTML]="item.description"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="subtitle" [innerHTML]="initialValue.secondaryCall"></div>
        <div
          class="description-area"
          *ngIf="initialValue.firstImageUrl || initialValue.description"
        >
          <img
            *ngIf="initialValue.firstImageUrl"
            class="first-image"
            [src]="initialValue.firstImageUrl"
            alt="logo da empresa"
          />
          <div
            *ngIf="initialValue.description"
            class="ol-template-slide-description"
            [innerHTML]="initialValue.description"
          ></div>
        </div>

        <div class="extra-info-area variable-wage" *ngIf="hiringBonus || iLP">
          <div class="infos">
            <div class="info first" *ngIf="hiringBonus">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/money.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ olNames ? olNames.variable_wage_1 : ("general.hiringBonus" | translate) }}
                </span>
                <span class="info-value" [innerHTML]="hiringBonus"></span>
              </div>
            </div>

            <div class="info" *ngIf="iLP">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/money.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title">{{ olNames ? olNames.variable_wage_2 : ("general.iLP" | translate) }} </span>
                <span class="info-value" [innerHTML]="iLP"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="extra-info-area">
          <div class="title">
            {{ "offerLetter.template.aditionalInfos" | translate }}
          </div>
          <div class="infos">
            <div class="info" *ngIf="gestor">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/person.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "general.manager" | translate }}:
                </span>
                <span class="info-value">{{ gestor }}</span>
              </div>
            </div>

            <div class="info" *ngIf="localTrabalho">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/map-marker.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "offerLetter.template.workplace" | translate }}:
                </span>
                <span class="info-value">{{ localTrabalho }}</span>
              </div>
            </div>

            <div class="info" *ngIf="modeloTrabalho">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/check-network.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "offerLetter.template.workModel" | translate }}:
                </span>
                <span class="info-value">{{ modeloTrabalho }}</span>
              </div>
            </div>

            <div class="info" *ngIf="cargaHoraria">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/clock.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "offerLetter.template.workload" | translate }}:
                </span>
                <span class="info-value">{{ cargaHoraria }}</span>
              </div>
            </div>

            <div class="info" *ngIf="escalaTrabalho">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/clock.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "offerLetter.template.workSchedule" | translate }}:
                </span>
                <span class="info-value">{{ escalaTrabalho }}</span>
              </div>
            </div>

            <div class="info" *ngIf="jornadaTrabalho">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/clock.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{ "offerLetter.template.workHours" | translate }}:
                </span>
                <span class="info-value">{{ jornadaTrabalho }}</span>
              </div>
            </div>

            <div class="info">
              <div class="info-icon">
                <svg-icon
                  class="hr-svg-icon"
                  src="/assets/icons/calendar-range.svg"
                ></svg-icon>
              </div>
              <div class="info-data">
                <span class="info-title"
                  >{{
                    "offerLetter.template.expectedAdmissionDate" | translate
                  }}:
                </span>
                <span class="info-value">{{ dataAdmissao }}</span>
              </div>
            </div>
          </div>

          <div class="ol-info-box" [innerHTML]="initialValue.note"></div>
        </div>
      </div>
    </div>
  </div>
</div>
